<template lang="pug">
  .view-control-categories-edit
    b-tabs.ui-tabs(v-model="activeTab")
      //- TAB: Общие данные
      b-tab-item
        template(slot="header")
          b-icon(icon="information-outline")
          span Общие данные
          b-icon(v-if="category.$isChanged" icon="asterisk" size="is-small" type='id-danger')
        layout-form(:value="category" form='category' back-link)

      //- TAB: Доступ
      b-tab-item(label="Доступ" v-if="category.id" icon="account-alert")
        layout-form(:value="category" form='resource-access' back-link)

</template>

<script>
import Category from '@/models/Category';

export default {
  name: 'view-control-categories-edit',

  data: () => ({
    category: new Category(),
    activeTab: 0,
  }),

  created() {
    this.category.$find(this.$route.params.id);
  },
};
</script>
